import { ClientReducer } from './client/reducer';
import { settingsReducer } from './settings/reducer';
import { pageDataReducer } from './page-data/reducer';
import { patientsReducer } from './patients/reducer';
import { tokenDataReducer } from './token/reducer';
import { tokenConDataReducer } from './consultant-token/reducer';
import { LanguageReducer } from './langugage/reducer';
import { WebSetteingReducer } from './webSetteing/reducer';
import { filterReducer } from './filter/reducer';

export {
  settingsReducer,
  pageDataReducer,
  patientsReducer,
  tokenDataReducer,
  tokenConDataReducer,
  ClientReducer,
  LanguageReducer,
  WebSetteingReducer,
  filterReducer
};
